import btoa from 'btoa';
import { appAssetsCdnUrl } from '~/constants/environment';
import { AppliedFilters } from '~/validations/AppliedFilters';

function createUrl(filters: AppliedFilters) {
  const cvnaId = btoa(JSON.stringify({ filters }));

  return `/cars/filters?cvnaid=${cvnaId}`;
}

type PopularModel = {
  image: string;
  make: string;
  model: string;
  url: string;
};

export const popularModels: PopularModel[] = [
  {
    image: `${appAssetsCdnUrl}/images/popular-models/rivian-r1st.png`,
    make: 'Rivian',
    model: 'R1S/R1T',
    url: createUrl({
      makes: [
        { name: 'Rivian', parentModels: [{ name: 'R1S' }, { name: 'R1T' }] }
      ]
    })
  },
  {
    image: `${appAssetsCdnUrl}/images/popular-models/tesla-model-3.png`,
    make: 'Tesla',
    model: 'Model 3',
    url: createUrl({
      makes: [{ name: 'Tesla', parentModels: [{ name: 'Model 3' }] }]
    })
  },
  {
    image: `${appAssetsCdnUrl}/images/popular-models/chevrolet-equinox.png`,
    make: 'Chevrolet',
    model: 'Equinox',
    url: createUrl({
      makes: [{ name: 'Chevrolet', parentModels: [{ name: 'Equinox' }] }]
    })
  },
  {
    image: `${appAssetsCdnUrl}/images/popular-models/nissan-rogue.png`,
    make: 'Nissan',
    model: 'Rogue',
    url: createUrl({
      makes: [{ name: 'Nissan', parentModels: [{ name: 'Rogue' }] }]
    })
  },
  {
    image: `${appAssetsCdnUrl}/images/popular-models/ford-escape.png`,
    make: 'Ford',
    model: 'Escape',
    url: createUrl({
      makes: [{ name: 'Ford', parentModels: [{ name: 'Escape' }] }]
    })
  },
  {
    image: `${appAssetsCdnUrl}/images/popular-models/ford-explorer.png`,
    make: 'Ford',
    model: 'Explorer',
    url: createUrl({
      makes: [{ name: 'Ford', parentModels: [{ name: 'Explorer' }] }]
    })
  },
  {
    image: `${appAssetsCdnUrl}/images/popular-models/toyota-camry.png`,
    make: 'Toyota',
    model: 'Camry',
    url: createUrl({
      makes: [{ name: 'Toyota', parentModels: [{ name: 'Camry' }] }]
    })
  },
  {
    image: `${appAssetsCdnUrl}/images/popular-models/honda-civic.png`,
    make: 'Honda',
    model: 'Civic',
    url: createUrl({
      makes: [{ name: 'Honda', parentModels: [{ name: 'Civic' }] }]
    })
  },
  {
    image: `${appAssetsCdnUrl}/images/popular-models/nissan-altima.png`,
    make: 'Nissan',
    model: 'Altima',
    url: createUrl({
      makes: [{ name: 'Nissan', parentModels: [{ name: 'Altima' }] }]
    })
  },
  {
    image: `${appAssetsCdnUrl}/images/popular-models/jeep-grand-cherokee.png`,
    make: 'Jeep',
    model: 'Grand Cherokee',
    url: createUrl({
      makes: [{ name: 'Jeep', parentModels: [{ name: 'Grand Cherokee' }] }]
    })
  },
  {
    image: `${appAssetsCdnUrl}/images/popular-models/ford-f150-supercrew.png`,
    make: 'Ford',
    model: 'F-150 SuperCrew',
    url: createUrl({
      makes: [
        {
          name: 'Ford',
          parentModels: [{ name: 'F-150' }]
        }
      ],
      truckCabTypes: ['Crew']
    })
  }
];
